import React, { createContext, useState, useContext, ReactNode } from 'react';

interface User {
    id: string;
    emailAddresses: Array<{ emailAddress: string }>;
    firstName: string;
    lastName: string;
    password: string;
    role: string;
    publicMetadata: { role: string; tenantCode?: string; branchAccessMode?: string; branchCodes?: string[] };
    // B3: quitar a alguien de las personas de contacto de un centro NO borra su
    // cuenta, la banea (mismo modelo que la baja de un cliente). El dato ya venía
    // —`getAllUsers` devuelve el objeto de Clerk tal cual— pero no se pintaba, así
    // que un usuario sin acceso se veía idéntico a uno activo.
    banned?: boolean;
    locked?: boolean;
    // Q1: desde que se invita en vez de crear con contraseña, el usuario de Clerk
    // no existe hasta que aceptan. `getAllUsers` devuelve también las invitaciones
    // pendientes con esta marca, para que dar de alta a alguien no parezca no haber
    // hecho nada.
    pendingInvitation?: boolean;
    invitationId?: string | null;
  // otros campos de usuario
}

interface UserContextType {
    users: User[];
    setUsers: React.Dispatch<React.SetStateAction<User[]>>;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [users, setUsers] = useState<User[]>([]);

    return (
        <UserContext.Provider value={{ users, setUsers }}>
        {children}
        </UserContext.Provider>
    );
};

export const useUserContext = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUserContext must be used within a UserProvider');
    }
    return context;
};